import { DControls } from "./controls-desktop";
import { MControls } from "./controls-mobile";

export * from "./preview";

export const Controls = {
  Desktop: DControls,
  Mobile: MControls,
};
